module.exports = __webpack_public_path__ + "static/NotoSans-Italic-afe1714f485b424f221147e1be6cf8ad.ttf";